import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BillingFacade, PRIORITY_SUPPORT_FEATURES } from '@app/shared/+state/billing';
import { SettingsService, calculateSupportTier } from '@app/shared/services/settings/settings.service';
import { isAfter } from 'date-fns';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-priority-support-add-on',
  templateUrl: './priority-support-add-on.component.html',
  styleUrls: ['./priority-support-add-on.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrioritySupportAddOnComponent implements OnInit {
  public canManageAddons$ = this.billingFacade.canManageAddons$;

  public addonData$ = combineLatest([this.settingsService.getPrioritySupportQuote(), this.authService.user$]).pipe(
    map(([quote, user]) => {
      const prioritySupportInGracePeriod =
        user.priority_support.priority_support_ends_at !== null &&
        isAfter(user.priority_support.priority_support_ends_at, new Date());
      const hasPrioritySupport = user.priority_support.priority_support || prioritySupportInGracePeriod;
      const selectedTier = calculateSupportTier(hasPrioritySupport, user.priority_support.priority_support_plan);

      return {
        quote,
        user,
        selectedTier,
        priorityPricing: {
          base_amount: quote.priority_support_base_addon_amount,
          per_property_amount: quote.priority_support_addon_amount_per_property,
        },
        readonly: user.priority_support.priority_support_ends_at !== null || selectedTier === 'vip',
      };
    })
  );

  public features = PRIORITY_SUPPORT_FEATURES;
  constructor(
    private readonly billingFacade: BillingFacade,
    private authService: AuthenticationService,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void { }
}
